import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavBarService {
  private sidenavState = signal<boolean>(false);
  // Expone la señal en modo solo lectura
  readonly sidenavState$ = this.sidenavState.asReadonly();
  
  setSidenavState(state: boolean) {
    this.sidenavState.set(state);
  }
}
